module.exports = __webpack_public_path__ + "static/best-relationship-fall-2021-e193d41c47df9ad43e86e2746aa7480f.svg";